import { useMemo } from 'react';

type LeaderboardTab = 'participants' | 'areas' | 'offices';

export const useLeaderboardPagination = (
  activeTab: LeaderboardTab,
  participantsTotalPages: number,
  participantsPage: number,
  districtsTotalPages: number,
  districtsPage: number,
  officesTotalPages: number,
  officesPage: number
) => {
  const totalPages = useMemo(() => {
    if (activeTab === 'participants') return participantsTotalPages;
    if (activeTab === 'areas') return districtsTotalPages;
    return officesTotalPages;
  }, [activeTab, participantsTotalPages, districtsTotalPages, officesTotalPages]);

  const currentPage = useMemo(() => {
    if (activeTab === 'participants') return participantsPage;
    if (activeTab === 'areas') return districtsPage;
    return officesPage;
  }, [activeTab, participantsPage, districtsPage, officesPage]);

  return { totalPages, currentPage };
};
